import { workLogs } from "@/api/workLogs/useWorksLogsQuery";
import { works } from "@/api/works/useWorkQuery";
import {
  NoDataTr,
  PaginationWrapper,
  TabBodyTable,
  TabBodyTitle,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  WorkTabBodyContainer,
} from "@/features/work/WorkView/WorkProductionHistory";
import { Pagination, Text } from "@mantine/core";
import {
  ProductionPlansGet200ResponseRowsInnerWorksInner,
  ProductionPlansGet200ResponseRowsInnerWorksInnerConsumeSummary,
  WorkLogsGet200ResponseRowsInnerWorkLogTypeEnum,
} from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface WorkInputLotProps {
  workId: number | undefined;
}

export const WorkInputLot = ({ workId }: WorkInputLotProps) => {
  const [activePage, setActivePage] = useState<number>(1);
  const { t } = useTranslation();

  const { data: workData } = useQuery(
    works.get({
      query: {
        $and: [{ id: { $eq: workId } }],
      },
      populate: ["inputSummary"],
    }),
  );

  const rows: ProductionPlansGet200ResponseRowsInnerWorksInner | undefined =
    workData?.data?.rows && workData?.data?.rows[0];

  const { data: workLogData } = useQuery(
    workLogs.get({
      query: {
        $and: [
          { workId: { $eq: workId ?? 0 } },
          { workLogType: WorkLogsGet200ResponseRowsInnerWorkLogTypeEnum.INPUT },
        ],
      },
      sort: "-id",
      page: activePage,
      populate: [
        "itemUnit",
        "defectName",
        "alreadyCanceled",
        "creatorUser",
        "downtimeReasonName",
        "getEquipment",
      ],
    }),
  );

  return (
    <WorkTabBodyContainer>
      <TabBodyTitle>
        <Text fz="xl" fw={500}>
          {t("inputLot.inputLot")}
        </Text>
        <Text fz="xs" fw={400}>
          {t("inputLot.description")}
        </Text>
      </TabBodyTitle>
      <TabBodyTable>
        <Thead>
          <Tr>
            <Th>{t("inputLot.material")}</Th>
            <Th>{t("lot.id")}</Th>
            <Th>{t("lot.name")}</Th>
            <Th>{t("inventory.quantity")}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {Array.isArray(rows?.inputSummary) && rows?.inputSummary.length ? (
            rows?.inputSummary?.map(
              (input: ProductionPlansGet200ResponseRowsInnerWorksInnerConsumeSummary) => (
                <Tr key={input.lotId}>
                  <Td>{input?.itemName}</Td>
                  <Td style={{ justifyContent: "flex-end" }}>{input?.lotId}</Td>
                  <Td>{input?.lotName}</Td>
                  <Td style={{ justifyContent: "flex-end" }}>{input?.sumQuantity}</Td>
                </Tr>
              ),
            )
          ) : (
            <NoDataTr>
              <Text>{t("inputLot.notFound")}</Text>
            </NoDataTr>
          )}
        </Tbody>
      </TabBodyTable>
      <PaginationWrapper>
        <Pagination
          onChange={setActivePage}
          value={activePage}
          total={workLogData?.data?.totalPages ?? 0}
          size="lg"
          radius="sm"
        />
      </PaginationWrapper>
    </WorkTabBodyContainer>
  );
};
